import { KYMW1310Model } from '../kymw1310.model';
import { KYMW1310PlanMultiPublishModel } from '../vo/kymw1310-plan-multi-publish.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * Ｗ掲載設定を取得する
 *
 * @export API通信成功時の処理
 * @class GetUserInfomationDetailService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPlanMultiPublishService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW1310Model;
  private successFunc: Function;
  private vo: KYMW1310PlanMultiPublishModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUserInfomationDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1310Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetUserInfomationDetailService
   */
  execute(model: KYMW1310Model, vo: KYMW1310PlanMultiPublishModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPlanMultiPublish', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUserInfomationDetailService
   */
  success(data: any) {
    this.model.updateKYMW1310(data);

  }
}
